import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { FullscreenErrorContainer } from '@/components/blocks/error-container';
import { FullscreenLoadingContainer } from '@/components/blocks/loading-container';
import { NoResults } from '@/components/blocks/no-results';

export interface LoadingErrorContentWrapperProps {
  children?: ReactNode;
  className?: string;
  errorContent?: ReactNode;
  errorFontSize?: string;
  errorMessage?: string;
  hasError: boolean;
  isLoading: boolean;
  loadingContent?: ReactNode;
  noResults?: boolean;
  noResultsContent?: ReactNode;
  refetch?: () => unknown | Promise<unknown>;
}

export const LoadingErrorContentWrapper: FC<
  LoadingErrorContentWrapperProps
> = ({
  children,
  className,
  errorContent,
  errorFontSize,
  errorMessage,
  hasError,
  isLoading,
  loadingContent,
  noResults = false,
  noResultsContent,
  refetch,
}): ReactNode => {
  const { t } = useTranslation();

  if (hasError) {
    return (
      errorContent ?? (
        <FullscreenErrorContainer
          className={className}
          errorMessage={errorMessage ?? t('general.toast.fetchFailed')}
          fontSize={errorFontSize}
          isLoading={isLoading}
          refetch={refetch}
        />
      )
    );
  }

  if (isLoading) {
    return (
      loadingContent ?? <FullscreenLoadingContainer className={className} />
    );
  }

  if (noResults) {
    return noResultsContent ?? <NoResults className={className} />;
  }

  return children;
};
